import { addProjectDefaults } from 'helpers/projects/projectDefaults'

const mapProject = p => ({
  title: p.title,
  id: p._id,
  createdAt: p.createdAt,
  updatedAt: p.updatedAt,
  deviceCount: p.cameras.filter(c => !c.imagerId).length + p.entities.doorControllers.allIds.length + p.entities.doors.allIds.length + p.entities.networkClosets.allIds.length + p.entities.wiredDevices.allIds.length
})

export default function applyProjects(state, action) {
  const { projects } = action
  const projectsWithDefaults = projects.map(addProjectDefaults)

  return Object.assign({}, state, {
    projects: [
      ...(state.projects || []),
      ...projectsWithDefaults.map(mapProject)
    ]
  })
}



// WEBPACK FOOTER //
// ./src/reducers/applyProjects.js